import type { Board } from "../board";
import { DamageType } from "../damageType";
import { ParticleEffect } from "../effects/particleEffect";
import {
	PRIORITY_DEFAULT,
	type ProcessableThing,
	type ProjectileHittable,
	type OnPlayerDriveOver,
} from "../interfaces";
import { ParticleType } from "../particleType";
import { PhysicalThingWithHp, STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import type { Thing } from "../thing";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";
import { DeadPlant } from "./deadPlant";

export class Plant extends PhysicalThingWithHp implements ProjectileHittable, OnPlayerDriveOver, ProcessableThing {
	static key = "Plant";
	constructor(xy: XY) {
		super(xy, false);
		this.hp = STD_BASE_HP;
		this.maxHp = STD_BASE_HP;
		this.damageMultipliers.set(DamageType.BUBBLE, 0);
	}

	getZOrder(): number {
		return ZOrder.SCENARIO;
	}

	onProjectileHit(_projectile: unknown): void {}

	isHittable(): boolean {
		return true;
	}

	onPlayerDriveOver(): void {
		this.kill();
	}

	processTurn(_board: Board): void {}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	protected onZeroHp(source: Thing | null, type: DamageType | null): void {
		const remnant = new DeadPlant(this.xy);
		this.board!.addThing(remnant);
		this.board!.addEffect(new ParticleEffect(this.xy, ParticleType.LEAF_DEBRIS, 6));
		super.onZeroHp(source, type);
	}

	static deserialize(data: any): Plant {
		const p = new Plant(deserializeXY(data.xy));
		p.restoreBaseFields(data);
		return p;
	}
}
